import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';
const IconEclipse = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.guageBlue, isdef }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <g filter='url(#filter0_d_5894_21871)'>
            <circle cx='8' cy='8' r='4' fill={color} />
        </g>
        {isdef && <defs>
            <filter id='filter0_d_5894_21871' x='0' y='0' width='16' height='16' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feMorphology radius='2' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_5894_21871' />
                <feOffset />
                <feGaussianBlur stdDeviation='1' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0.2 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.2 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_5894_21871' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_5894_21871' result='shape' />
            </filter>
        </defs>
        }
    </svg>;

};

IconEclipse.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isdef: PropTypes.bool
};

export default React.memo(IconEclipse);
